export const UI_VERSION = 'v1.596.0'
